// 請購相關 Modal 用：自繪捲軸（react-perfect-scrollbar）
import React, { useMemo } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './_pr-perfect-scrollbar.scss';

/**
 * perfect-scrollbar 判斷：containerHeight(getBoundingClientRect) + scrollYMarginOffset < scrollHeight
 * 才顯示直向捲軸。預設閾值偏大，避免只差一小段高度就出現捲軸。
 * 若仍太敏感，可傳 minOverflowYPx 或 options.scrollYMarginOffset。
 */
const DEFAULT_MIN_OVERFLOW_Y = 96;
const DEFAULT_MIN_OVERFLOW_X = 48;

const PrModalPerfectScrollbar = React.forwardRef(function PrModalPerfectScrollbar(
  {
    children,
    className = '',
    options,
    minOverflowYPx = DEFAULT_MIN_OVERFLOW_Y,
    minOverflowXPx = DEFAULT_MIN_OVERFLOW_X,
    containerRef,
    onSync,
    ...rest
  },
  ref
) {
  const mergedOptions = useMemo(() => {
    const yOffset =
      options != null && Object.prototype.hasOwnProperty.call(options, 'scrollYMarginOffset')
        ? options.scrollYMarginOffset
        : minOverflowYPx;
    const xOffset =
      options != null && Object.prototype.hasOwnProperty.call(options, 'scrollXMarginOffset')
        ? options.scrollXMarginOffset
        : minOverflowXPx;
    return {
      wheelPropagation: false,
      suppressScrollX: true,
      ...options,
      scrollYMarginOffset: yOffset,
      scrollXMarginOffset: xOffset,
    };
  }, [options, minOverflowYPx, minOverflowXPx]);

  const cn = ['pr-perfect-scrollbar', className].filter(Boolean).join(' ');

  return (
    <PerfectScrollbar
      ref={ref}
      className={cn}
      options={mergedOptions}
      containerRef={containerRef}
      onSync={onSync}
      {...rest}
    >
      {children}
    </PerfectScrollbar>
  );
});

export default PrModalPerfectScrollbar;
